import { MdOutlineSpaceDashboard } from 'react-icons/md';
import { AiOutlineProfile } from 'react-icons/ai';
import { BiErrorCircle } from 'react-icons/bi';
import { FiChevronDown } from 'react-icons/fi';

export const SIDEBAR_MENU = [
  {
    id: '1',
    text: '대시보드',
    icon: <MdOutlineSpaceDashboard />,
    path: '/admin',
  },
  {
    id: '2',
    text: '계약정보 관리',
    icon: <AiOutlineProfile />,
    downIcon: <FiChevronDown />,
    subMenu: [
      { id: '1', text: '계약 등록/조회', path: '/admin/contracts' },
      { id: '2', text: '장소 등록/조회', path: '/admin/places' },
      { id: '3', text: '장비 매칭/조회', path: '/admin/devices' },
    ],
  },
  {
    id: '3',
    text: '장애 이력',
    icon: <BiErrorCircle />,
    path: '/admin/error',
  },
];
